import { NgModule } from '@angular/core';
import { BlankPipe } from './blank.pipe';
import { FileSizePipe } from './file-size.pipe';

const pipes = [
  BlankPipe,
  FileSizePipe
];

@NgModule({
  declarations: pipes,
  exports: pipes,
})
export class PipesModule {
}
